import { normalize, schema } from "normalizr";

const accountsSchema = new schema.Entity("accounts");
const accountList = [accountsSchema];

export const normalizeData = data => normalize(data, accountList);
